import { Component, OnInit, NgZone } from '@angular/core';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebargestor',
  templateUrl: './sidebargestor.component.html',
  styleUrls: ['./sidebargestor.component.css']
})
export class SidebargestorComponent implements OnInit {
  isMenuOpen = true;
  contentMargin = 240;
  nombreUsuario = '';

  constructor(
    private Loginservicio: UsuarioService,
    private router: Router,
    private ngZone: NgZone

  ) { }


  onToolbarMenuToggle() {
    console.log('On toolbar toggled', this.isMenuOpen);
    this.isMenuOpen = !this.isMenuOpen;

    if (!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }

  ngOnInit() {
    this.nombreUsuario = this.Loginservicio.nombreempresa;

  }

  abrePermisos() {

    this.ngZone.run(() => this.router.navigate(['../gestores']));
  }


  abrelistadopermisosSolicitados() {
   ;
    this.ngZone.run(() =>  this.router.navigate(['../ticketgestor']));
  }


  logout(){
    localStorage.clear();
   this.router.navigate(['']);
  //window.open("https://www.sportfishingmx.com");

  }

}
